{
  "hub": {
    "kicker": "Small lessons. Useful skills.",
    "headline": "Learn to use AI.\nGet things done.",
    "lede": "A better email. A clearer plan. Your next idea, made real. Learn by trying, one practical lesson at a time.",
    "seoTitle": "Learn to Use AI to Get Things Done | Gab AI",
    "seoDescription": "Learn practical AI skills with free, step-by-step lessons. Write, research, understand files, plan projects, and create useful results with Gab AI and Work.",
    "seoKeywords": "learn AI, how to use AI, practical AI skills, AI writing, AI research, AI planning, Gab AI Work, AI tutorials"
  },
  "faqs": [
    {
      "q": "Do I need an account?",
      "a": "Every lesson is free to read without an account. Sign in to Gab AI when you want to run a project. Work tasks and media generation use credits; review your available balance before you start."
    },
    {
      "q": "Will my progress be saved?",
      "a": "Your completion marks and practice drafts save in this browser, including on shared devices. They do not sync between devices or accounts. If browser storage is unavailable, your work stays available for the current visit. Review checks and example questions start fresh when you reopen a lesson."
    },
    {
      "q": "Where should I start?",
      "a": "New to AI? Start with Your First Prompt. If you have a task in mind, choose a goal on this page and follow its suggested lessons. Move on to Work when you want the agent to carry out a project and create files you can review and edit."
    },
    {
      "q": "What is the difference between Chat and Work?",
      "a": "Use Chat to ask questions, work through an idea, or improve a draft together. Use Work for a project with multiple steps, tools, or files to create. The lessons show you how to give useful instructions and check the result in either case."
    },
    {
      "q": "How long does a project take?",
      "a": "The time on each lesson is an estimated reading time. Your project will take longer while Work creates files or generates media. Start small, review the first version, and leave time for revisions."
    },
    {
      "q": "Can I follow along on my phone?",
      "a": "You can read the lessons and start Work tasks on mobile. The editor walkthroughs describe Gab AI on the web; a larger screen is helpful for selecting image regions, reviewing video clips, and editing spreadsheets. Available controls vary by device and file type."
    }
  ],
  "paths": [
    {
      "id": "write",
      "label": "Write & communicate",
      "icon": "pen-fancy",
      "title": "Say what you mean, clearly.",
      "description": "Turn rough thoughts into a useful first draft, then make it sound like you.",
      "prompt": "Turn these notes into a friendly email: community garden cleanup Saturday, 9–11am, bring gloves, everyone welcome. Keep it under 80 words.",
      "lessons": [
        {
          "slug": "writing-assistant",
          "label": "Draft and edit with AI"
        },
        {
          "slug": "being-specific",
          "label": "Ask for the tone and format you need"
        },
        {
          "slug": "iterating-prompts",
          "label": "Improve the first draft"
        }
      ]
    },
    {
      "id": "research",
      "label": "Research & decide",
      "icon": "magnifying-glass",
      "title": "Make an informed choice.",
      "description": "Compare options, ask better follow-up questions, and check the sources behind an answer.",
      "prompt": "Compare these two venues using my notes. We expect 40 people and need step-free access. List the tradeoffs and what I should verify before booking.",
      "lessons": [
        {
          "slug": "research",
          "label": "Research and compare options"
        },
        {
          "slug": "voice-and-search",
          "label": "Find current information with web search"
        },
        {
          "slug": "common-mistakes",
          "label": "Check facts before relying on an answer"
        }
      ]
    },
    {
      "id": "files",
      "label": "Understand your files",
      "icon": "file-lines",
      "title": "Find the useful parts faster.",
      "description": "Ask questions about a file and turn its details into a summary you can check.",
      "prompt": "Read these project notes. Pull out each deadline, its owner, and the source page. Flag anything missing instead of guessing.",
      "lessons": [
        {
          "slug": "file-uploads",
          "label": "Upload a file and ask questions"
        },
        {
          "slug": "providing-context",
          "label": "Give AI the context it needs"
        },
        {
          "slug": "work-spreadsheets",
          "label": "Turn information into a working spreadsheet"
        }
      ]
    },
    {
      "id": "plan",
      "label": "Plan & organize",
      "icon": "list-check",
      "title": "Know what to do next.",
      "description": "Break a big task into manageable steps and keep the decisions in one place.",
      "prompt": "Help me plan a neighborhood plant swap. It is three weeks away. Create a short checklist for each week and flag decisions I still need to make.",
      "lessons": [
        {
          "slug": "first-prompt",
          "label": "Describe the task and your constraints"
        },
        {
          "slug": "collections-org",
          "label": "Keep related work together"
        },
        {
          "slug": "memory",
          "label": "Save context you use again"
        }
      ]
    },
    {
      "id": "create",
      "label": "Make visual content",
      "icon": "image",
      "title": "Make something people will notice.",
      "description": "Describe a visual idea, refine the image, and learn to turn it into a video.",
      "prompt": "Create a welcoming poster illustration for a neighborhood plant swap. Use a leafy green palette, a warm paper background, and room for the event details.",
      "lessons": [
        {
          "slug": "text-to-image",
          "label": "Describe an image you want to make"
        },
        {
          "slug": "work-images",
          "label": "Edit an image and create a new format"
        },
        {
          "slug": "work-videos",
          "label": "Plan, review, and finish a video"
        }
      ]
    },
    {
      "id": "build",
      "label": "Build with Work",
      "icon": "briefcase",
      "title": "Go from an idea to a working result.",
      "description": "Give Work a project, review what it makes, and guide the next version.",
      "prompt": "Build a simple neighborhood resource directory as an HTML page. Include three sample categories, mobile-friendly cards, and a search box. Test the search before delivering it.",
      "lessons": [
        {
          "slug": "agentic-workflows",
          "label": "Meet Gab AI Work"
        },
        {
          "slug": "briefing-agents",
          "label": "Write a brief Work can act on"
        },
        {
          "slug": "work-games",
          "label": "Build and test a playable game"
        }
      ]
    }
  ]
}
